import { useSelector } from 'react-redux';
import StateInterface from '../../redux/types';
import { trimTrailingSlash } from '../../urlService';
import useUserTracking from '../../hooks/flags/useUserTracking';
import useFeatureToggle from '../../hooks/useFeatureToggle';
import useConfig from '../../hooks/useConfig';
import useBellaTranslator from '../../hooks/useTranslator';

const useClubTabProps = () => {
    const t = useBellaTranslator();
    const config = useConfig();
    const clubHighlightTabUrl = useSelector<StateInterface, string>(
        state => state.configurations.clubHeaderHighlightTab && state.configurations.clubHeaderHighlightTab.url
    );
    const isEnabled = useSelector<StateInterface, boolean>(
        state => state.configurations.clubHeaderHighlightTab && state.configurations.clubHeaderHighlightTab.toggle
    );

    const {
        links: { clubBaseUrl, singleSignOn: singleSignOnUrl },
    } = config;

    let clubText = t('Westwing tab subline - Header redesign');
    const { isRegistered, didLoginFinishOnce, isLoggedIn } = useUserTracking();
    const { clubLinkTabHighlight } = useFeatureToggle();

    const isClubTabHighlighted = !!didLoginFinishOnce && !isRegistered && !!isEnabled && !!clubLinkTabHighlight;

    let clubUrl = clubBaseUrl;

    if (isClubTabHighlighted) {
        clubText = t('Club tab_new Club sales_desktop');
        clubUrl = trimTrailingSlash(clubUrl);
        clubUrl += clubHighlightTabUrl;
    }

    if (isLoggedIn) {
        clubUrl = singleSignOnUrl;
    }

    return { clubText, clubUrl, isClubTabHighlighted };
};

export default useClubTabProps;
